import useAgentData from '~/client/hooks/useAgentData';
import useCurrencyOptions from './useCurrencyOptions';
import useSelectedCurrency from './useSelectedCurrency';

const useGameCurrencySelect = () => {
  const { isDesktop } = useAgentData();
  const { handleChange, selectedCurrency, isDisabled } = useSelectedCurrency();
  const options = useCurrencyOptions(selectedCurrency);
  const isSelectedCurrencyInList = options.some(
    (option) => option.value === selectedCurrency,
  );

  return {
    isDisabled,
    options,
    isDesktop,
    selectedCurrency: isSelectedCurrencyInList ? selectedCurrency : undefined,
    handleChange,
  };
};

export default useGameCurrencySelect;
